let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("knVdf")).then(() => parcelRequire('fKfs1'));